module.exports = __webpack_public_path__ + "img/140.a74d892.svg";